import React, { Component } from 'react'
import AjaxHandler from '../../commons/ajax/AjaxHandler.js'
import {FormattedMessage, injectIntl} from 'react-intl';
import DropzoneComponent from 'react-dropzone-component/dist/react-dropzone'
import Config from '../../commons/config/Config.js'
import $ from 'jquery'
import Dialog from '../../commons/dialog/Dialog.js'

class Dropzone extends Component {
	constructor(props) {
		super(props);
		this.props = props;
        this.ajaxHandler = new AjaxHandler();
		this.state = {
            props: this.props,
            formData: {
				adjunto: null,
			},
		};
		
		this.initFileUpload();
        	// this.handleRemoveAdjunto = this.handleRemoveAdjunto.bind(this);

		// this.handleDownloadFile = this.handleDownloadFile.bind(this);
		this.handleCancel = this.handleCancel.bind(this);
		this.handleSave = this.handleSave.bind(this);        
		this.handleImportCancel = this.handleImportCancel.bind(this);
		this.dropzone = null;
	}

	handleImportCancel(mssg, sub, error) {
		this.resetModal(mssg, sub, error);
	}

	componentWillUnmount() {
		this.ajaxHandler.unsubscribe();
		if(this.props.onRef) this.props.onRef(undefined);
	}

	componentDidMount() {
		this.ajaxHandler = new AjaxHandler();
		this.ajaxHandler.subscribe(this);
		if(this.props.onRef) this.props.onRef(this);	
	}

    deleteAdjunto(file){
        this.props.setAdjunto(null)
        if(file.adjunto) {
            this.ajaxHandler.fetch('/ticket-presupuestos/adjunto/' + file.adjunto, {
                method: 'DELETE'
            })
            .then(response => {
                if (response.status !== 204) {
                    Dialog.alert(this.props.intl, {
                        title: this.props.intl.formatMessage({ id: 'ticketCargarPresupuesto.dialog_alert.information_error_al_eliminar_el_archivo.', defaultMessage: 'Error al eliminar el archivo.' })
                    });
                }
            }).catch((error) => {
                this.ajaxHandler.handleError(error);
            });
        }
    }

    initFileUpload() {
		let component = this;

		this.fileUploadConfig = {
			iconFiletypes: ['.pdf', '.jpg', '.png', '.gif', '.xls'],
			showFiletypeIcon: true,
			postUrl: `${Config.get('apiUrlBase')}/ticket-presupuestos/adjunto`
		};

		this.fileUploadDjsConfig = {
			height: '100px',
			width: '100px',
			acceptedFiles: "application/pdf,image/jpeg,image/png,image/gif/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
			addRemoveLinks: false,
			thumbnailMethod: 'crop',
			dictDefaultMessage: component.state.props.action !== 'VIEW' ? component.props.intl.formatMessage({ id: 'TicketCargarPresupuesto.add_file.label_haga_click_aqui_o', defaultMessage: 'Haga click aquí o' })+"<br>"+component.props.intl.formatMessage({ id: 'TicketCargarPresupuesto.add_file.label_arrastre_un_archivo_a_este_area', defaultMessage: ' arrastre un archivo a este área.' }) : '',
			uploadMultiple: true,
			parallelUploads: 1,
			headers: {
				"Authorization-Token": localStorage.getItem("token")
			},
			previewTemplate: `
		        <div class="dz-preview dz-image-preview">
		          <div class="dz-image">
		            <img data-dz-thumbnail src="/images/file.png" />
		          </div>
		          <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress="" style="width: 0%;"></span></div>
		          <div class="dz-success-mark">
		            <svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns">      <title>Check</title>      <defs></defs>      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">        <path d="M23.5,31.8431458 L17.5852419,25.9283877 C16.0248253,24.3679711 13.4910294,24.366835 11.9289322,25.9289322 C10.3700136,27.4878508 10.3665912,30.0234455 11.9283877,31.5852419 L20.4147581,40.0716123 C20.5133999,40.1702541 20.6159315,40.2626649 20.7218615,40.3488435 C22.2835669,41.8725651 24.794234,41.8626202 26.3461564,40.3106978 L43.3106978,23.3461564 C44.8771021,21.7797521 44.8758057,19.2483887 43.3137085,17.6862915 C41.7547899,16.1273729 39.2176035,16.1255422 37.6538436,17.6893022 L23.5,31.8431458 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z" id="Oval-2" stroke-opacity="0.198794158" stroke="#747474" fill-opacity="0.816519475" fill="#FFFFFF" sketch:type="MSShapeGroup"></path>      </g>    </svg>
		          </div>
		          <div class="dz-error-mark">
		            <svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns">      <title>Error</title>      <defs></defs>      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">        <g id="Check-+-Oval-2" sketch:type="MSLayerGroup" stroke="#747474" stroke-opacity="0.198794158" fill="#FFFFFF" fill-opacity="0.816519475">          <path d="M32.6568542,29 L38.3106978,23.3461564 C39.8771021,21.7797521 39.8758057,19.2483887 38.3137085,17.6862915 C36.7547899,16.1273729 34.2176035,16.1255422 32.6538436,17.6893022 L27,23.3431458 L21.3461564,17.6893022 C19.7823965,16.1255422 17.2452101,16.1273729 15.6862915,17.6862915 C14.1241943,19.2483887 14.1228979,21.7797521 15.6893022,23.3461564 L21.3431458,29 L15.6893022,34.6538436 C14.1228979,36.2202479 14.1241943,38.7516113 15.6862915,40.3137085 C17.2452101,41.8726271 19.7823965,41.8744578 21.3461564,40.3106978 L27,34.6568542 L32.6538436,40.3106978 C34.2176035,41.8744578 36.7547899,41.8726271 38.3137085,40.3137085 C39.8758057,38.7516113 39.8771021,36.2202479 38.3106978,34.6538436 L32.6568542,29 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z" id="Oval-2" sketch:type="MSShapeGroup"></path>        </g>      </g>    </svg>
		          </div>
		          <div class="dz-error-message"><span data-dz-errormessage></span></div>
		          <div class="dz-filename" style="width: 120px;"><span data-dz-name title="data-dz-name"></span></div>
		          <div class="dz-view"><a href="" target="_blank">VER</a></div>
		          ${component.state.props.action !== 'VIEW' ? '<div class="dz-remove"><a href="" data-dz-remove>'+component.props.intl.formatMessage({ id: 'ticketCargarPresupuesto.ELIMINAR', defaultMessage: 'ELIMINAR' })+'</a></div>' : ''}
		        </div>
		    `,
			init: function() {
				let dropzone = this;

				this.on('success', (file, response) => {
					file.adjunto = response.archivo;
                    component.state.props.setAdjunto(response.archivo)
				});

				this.on('removedfile', (file) => {
					component.deleteAdjunto(file);
				});

				this.on('error', (file, errormessage, response) => {
					dropzone.removeFile(file);
					Dialog.alert(component.props.intl, {
						title: errormessage.includes('files of this type') ? component.props.intl.formatMessage({ id: 'ticketCargarPresupuesto.add_file.error_formato_de_archivo_invalido', defaultMessage: 'Formato de archivo inválido' }) : component.props.intl.formatMessage({ id: 'ticketCargarPresupuesto.add_file.error_error_al_cargar_el_archivo', defaultMessage: 'Error al cargar el archivo.' })
					});
				});

				this.on('addedfile', function(file) {
					if (this.files.length > 1) {
		              this.removeFile(this.files[0]);
		            }
		            $(file.previewElement).find('.dz-image').on("click", function() {
		              dropzone.hiddenFileInput.click();
		            });
					$(file.previewElement).find('.dz-view > a').on('click', (e) => {
						component.ajaxHandler.fetch('/ticket-presupuestos/adjunto/' + file.adjunto, {
							method: 'GET',
							headers: {
								'Authorization-Token': localStorage.getItem("token")
							}
						}).then(response => {
							if (response.status === 200) {
								return response.blob();
							}
						}).then(fileBlob => {
							let fileUrl = URL.createObjectURL(fileBlob);
							window.open(fileUrl);
						}).catch(() => {});

						e.preventDefault();
					});
				});

				if (component.state.props.action === 'VIEW') {
					dropzone.disable();
				}
			}
		};

		this.fileUploadHandlers = {
			init: dz => {
				this.adjuntosDropzone = dz;
			}
		};
	}

    handleViewAdjunto(e, adjunto) {
        this.ajaxHandler.fetch('/ticket-presupuestos/adjunto/' + adjunto, {
          method: 'GET'
        }).then(response => {
          if (response.status === 200) {
            return response.blob();
          }
        }).then(fileBlob => {
          let fileUrl = URL.createObjectURL(fileBlob);
          window.open(fileUrl);
        }).catch(() => {
        });
        e.preventDefault();
        }


	handleCancel() {
		this.setState({			
			archivo: null,
			loading: false
		});
		this.dropzone.removeAllFiles();
		this.ajaxHandler.unsubscribe();
		this.props.callbackCancel();
	}
	
	handleSave(event) {
		this.setState({loading: true },()=>this.dropzone.processQueue());
		event.preventDefault();
	}


	render() {
		const eventHandlers = {
			init: dz => {
				this.adjuntosDropzone = dz;
			}
        }
		
		return (
			<React.Fragment>
                <DropzoneComponent id="archivos" config={this.fileUploadConfig} eventHandlers={eventHandlers} djsConfig={this.fileUploadDjsConfig} />
			</React.Fragment>
		);
	}
}

export default injectIntl(Dropzone);